module.exports = [{
      plugin: require('D:/BuildAgent2/work/69bf75cf03525213/node_modules/gatsby-plugin-web-font-loader/gatsby-browser.js'),
      options: {"plugins":[],"typekit":{"id":"kvs8isi"}},
    }]
